export default __webpack_public_path__ + "static/media/card-4.b648fda9.png";